import { IconProps } from '@/components/Icons/types/IconInterface';
import cn from '@/utils/cn';
import { iconVariant } from '@/components/Icons/iconVariant';
import React from 'react';

const IRDIcon = ({ size, variant, className }: IconProps) => {
  return (
    <svg
      className={cn(iconVariant({ variant, size, className }))}
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_141_9374)">
        <circle cx="25" cy="25" r="25" fill="white" />
        <path
          d="M0 25.0797C0 11.2426 11.1893 0.0227928 24.9887 3.44912e-05C38.788 -0.0227238 49.9773 11.2199 50 25.0569C50 37.9609 40.2406 48.7483 27.4399 50V36.1402C27.4399 32.863 27.9392 31.4748 29.5052 28.4707C32.6146 22.6673 37.1993 23.5321 36.9496 24.1238C36.3595 25.5121 35.951 26.2631 35.951 27.8334C35.951 30.8603 38.266 32.772 41.1257 32.772C44.2805 32.8403 46.8906 30.3369 46.9587 27.1962V27.0141C46.9587 22.8039 44.2351 20.1867 40.1498 20.1867C34.7254 20.1867 29.0513 24.3059 27.5987 28.9941H27.4399V20.3687C23.6496 20.3687 19.882 20.7101 16.0917 20.7101H11.7113V23.0314H13.1866C14.7753 23.0314 16.0917 24.3287 16.0917 25.9445V48.5663C6.40036 44.7884 0.0226963 35.4575 0 25.0797ZM14.9569 9.85438C14.9569 13.3364 17.7712 16.1812 21.2665 16.1812C24.7617 16.1812 27.576 13.3592 27.576 9.85438C27.576 6.3496 24.7617 3.52757 21.2665 3.52757C17.7712 3.55033 14.9569 6.37236 14.9569 9.85438Z"
          fill="#0D8390"
        />
      </g>
      <defs>
        <clipPath id="clip0_141_9374">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IRDIcon;
